import { ActionTypes } from '../constants/ActionTypes';
import { AnyAction } from 'redux';
import { IRegisterCustomer } from '../models/IRegisterCustomer';


export function RegisterReducer(state: IRegisterCustomer | null = null, action: AnyAction): IRegisterCustomer | null {
    switch (action.type) {
        case ActionTypes.SET_REGISTER_DATA:
            return SetRegisterData(action);
    }
    return state;
}

function SetRegisterData(action): IRegisterCustomer {
    return action.payload as IRegisterCustomer;
}


// WEBPACK FOOTER //
// ./src/reducers/RegisterReducer.tsx